<template>
  <header>
  <!--HEADER TOP-->
  		<div class="header-top">
  			<div class="container" id="header-body">
  			<ul class="left-nav">
  				<li><i class="top_icon1 icons"></i><a href="javascript:;" @click="testUserId()">HK</a></li>
  				<li><i class="top_icon2 icons"></i><a href="javascript:;">Boutiques</a></li>
  				<li><i class="top_icon3 icons"></i>+852 99008866</li>
  			</ul>
  			<ul class="right-nav">
  				<li><a href="/user" class="top_icon4 icons">login</a></li>
  				<li><router-link :to="{path: 'user',query:{current: 'user-MyWishlist'}}" class="top_icon5 icons">MyWishlist</router-link></li>
  				<li><a href="/shoppingBag" class="top_icon6 icons">Shopping Bag</a></li>
  			</ul>
  			</div>
  		</div>

  </header>
</template>

<script>
import { getUserAddressDefault } from '@/api/address'
export default {
  data() {
    return {

    }
  },
  methods: {
    testUserId() {
      console.log('user id: ', this.$store.getters.userId)
      getUserAddressDefault(this.$store.getters.userId).then(response => {
        console.log('response:', response)
      }).catch(err => {
        console.log('err：', err)
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/layout/XhHeader.vue